module.exports = __webpack_public_path__ + "img/consultoria2_4-3_3072.d90d5783.webp";